import {
  getLogin,
  signUp,
  validateOtp,
  verifyForgotUserOtp,
  verifyUserOtp,
} from '../../../apiCalls/urls/urlFunction';
import { isValidName, validateEmail, validatePhone } from '../../../shared/validation';

export function userLoginValidation(mobile, upassword) {
  const password = String(upassword).trim();

  // Object to store the response details
  let response = {
    success: false,
    message: '',
    data: null,
    phone: false,
    password: false,
  };

  // Validate the mobile number
  const cleanedMobile = String(mobile).replace(/\D/g, '');
  const phoneValidation = validatePhone(cleanedMobile);

  if (!phoneValidation.status) {
    response.message = phoneValidation.message;
    response.phone = true;
    return response;
  }

  // Check if the password is provided
  if (!password) {
    response.message = 'Password is required!';
    response.password = true;
    return response;
  }

  // Check if the password length meets the minimum requirement
  if (password.length < 3) {
    response.message = 'Password must be at least 3 characters long!';
    response.password = true;
    return response;
  }

  // If all validations pass, set success to true and include any relevant data
  response.success = true;
  response.message = 'Login successful!';
  response.data = { mobile: cleanedMobile, password };

  return response;
}

export async function loginUser(mobile, password) {
  const payload = { mobile, password };

  let loginResponseStatus = {
    status: true,
    mobile: null,
    error: false,
    message: null,
  };

  const loginResponse = await getLogin(payload);

  if (loginResponse?.data?.status) {
    loginResponseStatus.mobile = mobile;
    loginResponseStatus.message = loginResponse?.data?.message;
  } else {
    loginResponseStatus.status = false;
    loginResponseStatus.error = true;
    loginResponseStatus.mobile = mobile;
  }

  return loginResponseStatus;
}

export const handleOtpSubmit = (otp) => {
  const trimOtp = otp.trim();
  let otpValidationResponse = {
    status: true,
    userOTP: null,
  };

  if (trimOtp.length === 6) {
    otpValidationResponse.userOTP = trimOtp;
  } else {
    otpValidationResponse.status = false;
  }

  return otpValidationResponse;
};

export const verifyUserOTPForLogin = async (mobile, otp) => {
  return await verifyUserOtp({
    mobile,
    otp,
  });
};

export const verifyForgotUserOTP = async (mobile, otp) => {
  return await verifyForgotUserOtp({
    mobile,
    otp,
  });
};

export const newUserInputValidate = (formData) => {
  const { name, email, password } = formData;
  const errorObject = {
    nameError: { title: name, status: false, message: '' },
    emailError: { title: email, status: false, message: '' },
    passwordError: { title: password, status: false, message: '' },
    isAnyError: false,
  };

  // Validate Name
  const isValidUserName = isValidName(name);
  if (!isValidUserName.status) {
    errorObject.nameError.status = true;
    errorObject.nameError.message = isValidUserName.message;
    errorObject.isAnyError = true;
  }

  // Validate Email
  const isValidEmail = validateEmail(email);
  if (!isValidEmail.status) {
    errorObject.emailError.status = true;
    errorObject.emailError.message = isValidEmail.message;
    errorObject.isAnyError = true;
  }

  // Validate Password
  if (!password || password.length < 6) {
    errorObject.passwordError.status = true;
    errorObject.passwordError.message = 'Password must be at least 6 characters long.';
    errorObject.isAnyError = true;
  }

  return errorObject;
};

export const userForgotPassword = async (mobile) => {
  const response = await validateOtp(mobile);
  return response;
};

export const isAlphaNumericChar = (char) => {
  if (!char) return false;
  const code = char.charCodeAt(0);
  return (
    (code >= 65 && code <= 90) || // A-Z
    (code >= 97 && code <= 122) || // a-z
    (code >= 48 && code <= 57)
  ); // 0-9
};

export const isAlphaKey = (char) => {
  if (!char) return false;
  const code = char.charCodeAt(0);
  return (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
};

export const isNumberKey = (char) => {
  if (!char) return false;
  const code = char.charCodeAt(0);
  return code >= 48 && code <= 57; // Only 0-9
};

const getCharCode = (char) => (char ? char.charCodeAt(0) : 0);

export const isEmailChar = (char) => {
  const code = getCharCode(char);
  return (
    (code >= 48 && code <= 57) || // 0-9
    (code >= 65 && code <= 90) || // A-Z
    (code >= 97 && code <= 122) || // a-z
    code === 64 || // @
    code === 46 || // .
    code === 95 || // _
    code === 45
  ); // -
};

export const isValidPasswordChar = (char) => {
  if (!char) return false;

  const code = char.charCodeAt(0);

  const isAlpha = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
  const isDigit = code >= 48 && code <= 57;
  const isAllowedSymbol = [
    '+',
    '-',
    '@',
    '#',
    '$',
    '_',
    '!',
    '%',
    '`',
    '~',
    '^',
    '&',
    '*',
    '(',
    ')',
    '=',
    ';',
    ':',
    '|',
  ].includes(char);

  return isAlpha || isDigit || isAllowedSymbol;
};

// export const isAlphaNumericChar = (char) => {
//     if (!char) return false;

//     const code = char.charCodeAt(0);

//     const isAlpha = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
//     const isDigit = code >= 48 && code <= 57;

//     return isAlpha || isDigit;
// };

export const isValidCityChar = (char) => {
  if (!char) return false;

  const code = char.charCodeAt(0);
  const isAlpha = (code >= 65 && code <= 90) || (code >= 97 && code <= 122);
  const isSpace = code === 32;
  const isComma = char === ',';

  return isAlpha || isSpace || isComma;
};
